import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { pick } from 'lodash/fp'

import authReducer from './auth/authReducer'
import history from './history'
import ordersReducer from './orders/ordersReducer'
import accountsReducer from './accounts/accountsReducer'
import usersReducer from './users/usersReducer'
import managerReducer from './manager/managerReducer'
import locationsReducer from './accounts/locationsReducer'
import cycleCountsReducer from './accounts/cycleCountsReducer'
import messagesReducer from './messages/messagesReducer'
import internalMessagesReducer from './messages/internalMessagesReducer'
import speciesReducer from './species/speciesReducer'
import { CLEAR_STATE } from './auth/authActions'
import { Action } from './types/common'

const reducer = combineReducers({
  router: connectRouter(history),
  auth: authReducer,
  users: usersReducer,
  accounts: accountsReducer,
  orders: ordersReducer,
  manager: managerReducer,
  locations: locationsReducer,
  cycleCounts: cycleCountsReducer,
  messages: messagesReducer,
  internalMessages: internalMessagesReducer,
  species: speciesReducer,
})

export default (state: any, action: Action<any>) =>
  reducer(
    action.type === CLEAR_STATE ? pick('auth.meta', state) : state,
    action,
  )
